module.exports = __webpack_public_path__ + "static/media/irregular_pic_white.e3ec39e9.png";